export default function () {
  const { hooks } = useNuxtApp();
  const platformStore = usePlatformStore();

  const hasAppResolved = useState("hasAppResolved", () => false);
  hooks.hook("app:suspense:resolve", () => {
    hasAppResolved.value = true;
  });

  return computed(() => {
    return (
      hasAppResolved.value && Boolean(platformStore.tryGetPlatformConfiguration)
    );
  });
}
